var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.user
        ? "custPersonalAccount"
        : "custPersonalAccount public-page",
      staticStyle: { "min-height": "100vh" }
    },
    [
      _c("link", {
        attrs: {
          rel: "stylesheet",
          media: "all",
          type: "text/css",
          href: "../../static/front/all.min.css"
        }
      }),
      _vm._v(" "),
      _c("link", {
        attrs: {
          rel: "stylesheet",
          media: "all",
          type: "text/css",
          href: "../../static/front/style.css"
        }
      }),
      _vm._v(" "),
      _c("link", {
        attrs: {
          rel: "stylesheet",
          media: "all",
          type: "text/css",
          href: "../../static/front/custom_style.css"
        }
      }),
      _vm._v(" "),
      ![
        "purchase-token",
        "upgrade-membership",
        "profile-upgrade-membership",
        "billing-token-mobile"
      ].includes(_vm.$route.name)
        ? _c("HeaderBusiness")
        : _vm._e(),
      _vm._v(" "),
      _c("div", [_c("router-view", { attrs: { name: "business" } })], 1),
      _vm._v(" "),
      ![
        "purchase-token",
        "upgrade-membership",
        "profile-upgrade-membership",
        "billing-token-mobile"
      ].includes(_vm.$route.name)
        ? _c("FooterBusiness")
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4292f7b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4292f7b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BusinessPanel.vue
// module id = null
// module chunks = 